/**
 * @file        src/api/seo.js
 * @description Public SEO read: the resolved head tags for one storefront path
 *              (GET /seo?path=&host=). The backend answers the title, meta,
 *              Open Graph / Twitter, canonical, robots, JSON-LD, verification
 *              and analytics ids for this tenant + brand; src/lib/seoHead.js
 *              writes them into <head>. BYTE-IDENTICAL in the neon and beyond
 *              builds.
 * @author      Kinetika Labs
 * @created     2026-10-09
 * @changelog
 *   - 2026-10-09 Claude — Initial (SEO Management).
 */
import { get } from './client.js';

/**
 * @param {string} path  The router pathname (location.pathname, basename-free).
 * @returns {Promise<object>} The resolved SEO record (`data` of the envelope).
 */
export async function fetchSeo(path) {
  const host = typeof window !== 'undefined' ? window.location.host : '';
  const body = await get('/seo', { params: { path, host } });
  if (!body || body.success === false || !body.data) {
    throw new Error(body?.message || 'SEO record unavailable');
  }
  return body.data;
}
